<img [src]="'logo-splash-screen' | assetsSource" alt="logo" />
<div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
</div>
